import { useMainContext } from "../../../context/MainContext";
import { useStructureContext } from "../../../context/StructureContext";
import { headerBatches } from "../../../data/admin";
import StdTable from "./StdTable";

export default function BatchesBox() {
  const { openBatchRecords } = useMainContext();
  const { type, searchValues, section } = useStructureContext();

  return "CODBAT" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={headerBatches}
        data={
          "results" in searchValues[section.id]
            ? searchValues[section.id].results
            : []
        }
        onDoubleClick={(data, index) => openBatchRecords(data)}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
